module.exports = "/images/social-media-post.svg?f2ce83a49e55f5336eb51b140998c33f";